export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/IV/IV_iodine_12/configuration.json";